import type { StrategySortValues } from 'src/hooks/strategy/useStrategyMetricSort';

export const ZOOM_STEP = 1.25;
export const MIN_ZOOM = 4;
export const MAX_ZOOM = 15;

/** Map results sort for a single chain whose metrics have no display option. */
export const MAP_RESULTS_FALLBACK_SORT: StrategySortValues = {
  sort: 'added_at',
  order: 'desc',
  sort_metric: null,
};
